{
  "appName": "Al-Musafer Fuel",
  "brand": "Al-Musafer",
  "platform": "Platform",
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "create": "Create",
    "search": "Search",
    "retry": "Refresh",
    "close": "Close",
    "confirm": "Confirm",
    "apply": "Apply",
    "reset": "Reset",
    "rotate": "Rotate",
    "view": "View",
    "expandAll": "Expand all",
    "collapseAll": "Collapse all",
    "addItem": "Add item"
  },
  "yes": "Yes",
  "no": "No",
  "nav": {
    "dashboard": "Dashboard",
    "users": "Users",
    "settings": "Settings",
    "logout": "Log out"
  },
  "language": {
    "label": "Language",
    "ar": "العربية",
    "en": "English",
    "switchTo": {
      "ar": "Switch to Arabic",
      "en": "Switch to English"
    }
  },
  "theme": {
    "switchToLight": "Switch to light mode",
    "switchToDark": "Switch to dark mode"
  },
  "preferences": {
    "label": "Language and appearance settings"
  },
  "state": {
    "loading": "Loading…",
    "empty": "No data",
    "error": "Something went wrong"
  },
  "pagination": {
    "page": "Page {{page}} of {{totalPages}}",
    "total": "{{total}} records",
    "next": "Next",
    "previous": "Previous",
    "label": "Pagination",
    "morePages": "More pages"
  },
  "search": {
    "noResults": "No results match your search",
    "placeholder": "Search..."
  },
  "identity": {
    "nameNotProvided": "Name not provided"
  },
  "selectItem": {
    "placeholder": "Select an item...",
    "selected": "Item selected"
  },
  "multiselect": {
    "selectSomeItems": "Select items"
  },
  "media": {
    "imageViewer": "Image viewer",
    "viewLarger": "View larger",
    "editImage": "Edit image",
    "cropAndAdjust": "Crop the image and adjust it",
    "zoom": "Zoom",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "rotation": "Rotation",
    "cameraCapture": "Camera capture",
    "positionInFrame": "Position yourself in the frame",
    "takePhoto": "Take photo",
    "uploadFile": "Upload file",
    "uploaded": "Uploaded",
    "dragDropImage": "Drag and drop an image here",
    "selectedLabel": "Selected",
    "deleteTitle": "Delete {{name}}?",
    "deleteMessage": "{{name}} will be removed. This cannot be undone."
  },
  "treeDemo": {
    "title": "File explorer",
    "searchPlaceholder": "Search files",
    "reports": "Reports",
    "salesReport": "Sales report",
    "inventoryReport": "Inventory report",
    "documents": "Documents",
    "invoiceTemplate": "Invoice template",
    "configurations": "Configurations"
  },
  "table": {
    "resetFilters": "Reset filters",
    "clearFilter": "Clear filter: {{label}}",
    "sortBy": "Sort by {{column}}",
    "sortedAscending": "sorted ascending",
    "sortedDescending": "sorted descending",
    "selectRow": "Select row",
    "selectAllRows": "Select all rows",
    "selectPage": "Select all on this page",
    "selectAllMatching": "Select all {{count}} matching records",
    "selectedCount": "{{count}} selected",
    "clearSelection": "Clear selection",
    "permissionDeniedTitle": "You cannot view this data",
    "permissionDeniedDescription": "You do not have permission to view this data.",
    "initialEmptyTitle": "No records yet",
    "filteredEmptyDescription": "Try a different search or adjust your filters.",
    "errorDescription": "Try again, or contact your administrator if this keeps happening.",
    "partialTitle": "Some data could not load",
    "loading": "Loading records",
    "pageSizeLabel": "Rows per page",
    "moreActions": "More actions",
    "actions": "Actions",
    "rowActionsLabel": "Actions for {{name}}"
  },
  "combobox": {
    "clearSelection": "Clear selection",
    "search": "Search...",
    "options": "Options"
  },
  "password": {
    "show": "Show password",
    "hide": "Hide password"
  },
  "breadcrumb": {
    "label": "Breadcrumb",
    "more": "More"
  },
  "toaster": {
    "label": "Notifications"
  }
}
